import React, { useCallback } from 'react';
import { isDebug } from '@core/debug';
import { useContextTranslation } from '@core/i18n';
import { isIOS } from '@core/userAgent';
import { isIVS } from '@core/video/videoElementWrapper/helpers';
import UnstyledButton from '@embed/components/common/UnstyledButton';
import { ModalType } from '@embed/components/VideoPlayer/Player3/components/modals/VideoSettingsMenu/types';
import { useVideoEl } from '@embed/components/VideoPlayer/Player3/hooks/useVideoEl';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import Modal from '@player/components/Modal';
import { PlayerModalType, selectors, } from '@player/features/modal/modalRegistry';
/**
 * Button component to open IVS Quality selection modal
 * Only visible when debug console is open and video is an IVS stream
 */
export const IVSQualityButton = ({ onClose, }) => {
    const videoEl = useVideoEl();
    const { t } = useContextTranslation();
    const { showModal, hideModal } = useStore(selectors.modalActionsSelector);
    const handleQuality = useCallback(() => {
        onClose();
        showModal(ModalType.IVS_QUALITY, PlayerModalType.IVS_QUALITY, {
            onDismiss: () => hideModal(ModalType.IVS_QUALITY),
        });
    }, [onClose, showModal, hideModal]);
    // Ignore for non-IVS streams
    // Ignore for iOS (ipadOS) as it's not supported
    if (!isDebug() || !isIVS(videoEl) || isIOS) {
        return null;
    }
    // Compute quality label directly
    let qualityLabel = t('player:Quality');
    try {
        if (videoEl.isAutoQualityMode()) {
            qualityLabel = t('player:Quality (Auto {{videoQualityLabel}})', {
                videoQualityLabel: videoEl.quality,
            });
        }
        else {
            qualityLabel = t('player:Quality ({{videoQualityLabel}})', {
                videoQualityLabel: videoEl.quality,
            });
        }
    }
    catch (error) {
        // Silently handle errors
    }
    return (<Modal.Item button>
      <UnstyledButton onClick={handleQuality}>{qualityLabel}</UnstyledButton>
    </Modal.Item>);
};
